import "./RequiredLabel.css";

export const RequiredLabel = ({ children, className = "" }) => (
  <span className={`required-label${className ? ` ${className}` : ""}`}>
    {children} <span className="required-label__asterisk">*</span>
  </span>
);